import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import * as firebase from 'firebase';
import { AlertService } from '../../../_services/alert.service';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'underscore';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-food-activity',
  templateUrl: './food-activity.component.html',
  styleUrls: ['./food-activity.component.css']
})
export class FoodActivityComponent implements OnInit {
  modalRef: any;
  iconTab: FormGroup;
  meals = ['Yes', 'No'];
  members = ['Walter White', 'Jessy Pinkman', 'Heisenberg', 'Skylar White', 'Saul Goodman']
  modes = ['Bus', 'Train']
  mealTypes = ['Personal', 'Client', 'Team']
  mealSession = ['Breakfast', 'Lunch', 'Dinner', 'Others']

  private activityList: Array<any> = [];
  tagList = [];
  isLoading: any = false;
  isUploading: any = false;
  selectedItems = [];
  snapList: any = [];
  diffList = [];
  dropdownSettings = {};
  keyIndex: any = -1;
  minDate: any;
  maxDate: any;
  startDate: any;
  currMinDate: any;
  currMaxDate: any;
  addedBy: any;
  verifyFields = [
    {
      "key": "mealSession",
      "value": "MealSession"
    },
    {
      "key": "meetingStartDate",
      "value": "FoodStartDate",
      "isDate": true
    },
    {
      "key": "meetingEndDate",
      "value": "FoodEndDate",
      "isDate": true
    },
    {
      "key": "mealType",
      "value": "MealType"
    },
    {
      "key": "restuarant",
      "value": "Restuarant"
    },
    {
      "key": "startTimeFood",
      "value": "StartTimeFood"
    },
    {
      "key": "endTimeFood",
      "value": "EndTimeFood"
    },
    {
      "key": "reservation",
      "value": "Reservation"
    },
    {
      "key": "paidByFood",
      "value": "PaidByFood"
    },
    {
      "key": "tagMembersFood",
      "value": "TagMembersFood"
    },
    {
      "key": "otherInfoFood",
      "value": "OtherInfoFood"
    },
    {
      "key": "transNumberFood",
      "value": "TransNumberFood"
    },
    {
      "key": "merchNameFood",
      "value": "MerchNameFood"
    }
  ]

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };
  }

  @Input() data: any;
  @Input() travellers: any;
  @Input() code: any;
  @Input() createdBy: any;
  @Input() isReadOnly: any;
  @Input() isDisabled: any;
  @Input() isActivityEdit: any;
  @Output() flightData: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {

    this.iconTab = this.formBuilder.group({
      activityDetails: [[]],

      // Food Activity
      mealType: ['', Validators.required],
      restuarant: ['', Validators.required],
      meetingStartDate: ['', Validators.required],
      // foodStartDate: ['', Validators.required],
      meetingEndDate: ['', Validators.required],
      // foodEndDate: ['', Validators.required],
      meetingStart: ['', Validators.required],
      // foodStart: ['', Validators.required],
      meetingEnd: ['', Validators.required],
      // foodEnd: ['', Validators.required],
      startTimeFood: ['', Validators.required],
      endTimeFood: ['', Validators.required],
      reservation: ['', Validators.required],
      paidByFood: ['', Validators.required],
      tagMembersFood: ['', Validators.required],
      otherInfoFood: ['', Validators.required],
      transNumberFood: ['', Validators.required],
      merchNameFood: ['', Validators.required],
      mealSession: ['', Validators.required],
      otherMealSession: ['', Validators.required],
      createdBy: ['', Validators.required],

    });

    this.tagList = this.travellers;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.iconTab.patchValue(this.data);
    this.addedBy = this.data ? this.data.createdBy : this.createdBy;
    this.createdBy = this.data ? this.data.createdBy : this.createdBy + " - " + this.code;
    this.snapList = this.data ? this.data.snapList : '' || [];
    this.selectedItems = this.data ? this.data.tagMembersFood : '' || [];
  }

  get f() {
    return this.iconTab.controls;
  }

  getDiffItem(key: any, val: any) {
    let d = _.groupBy(this.diffList, 'key')[key]
    if (d && d.length) {
      return d[0][val]
    }
  }

  displayMembers(allMembers: any) {
    console.log(allMembers);
    allMembers = allMembers.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,',  ');
    return allMembers;
  }


  foodActivity() {
    // this.isLoading = true
    this.activityList.push({
      category: "Food",
      mealType: this.iconTab.value.mealType,
      restuarant: this.iconTab.value.restuarant,
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      startTimeFood: this.iconTab.value.startTimeFood,
      endTimeFood: this.iconTab.value.endTimeFood,
      reservation: this.iconTab.value.reservation,
      paidByFood: this.iconTab.value.paidByFood,
      tagMembersFood: this.iconTab.value.tagMembersFood || '',
      otherInfoFood: this.iconTab.value.otherInfoFood,
      transNumberFood: this.iconTab.value.transNumberFood || '',
      merchNameFood: this.iconTab.value.merchNameFood,
      mealSession: this.iconTab.value.mealSession,
    })
    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: "Food",
      mealType: '',
      restuarant: '',
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      startTimeFood: '',
      endTimeFood: '',
      reservation: '',
      paidByFood: '',
      tagMembersFood: '',
      otherInfoFood: '',
      transNumberFood: '',
      merchNameFood: '',
      mealSession: '',
    })
  }

  editFoodActivity(index, content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'animated fadeInDown', size: 'lg' });
    this.keyIndex = index;
    this.iconTab.patchValue({
      mealType: this.activityList[index].mealType,
      restuarant: this.activityList[index].restuarant,
      meetingStartDate: this.activityList[index].meetingStartDate,
      meetingEndDate: this.activityList[index].meetingEndDate,
      meetingStart: this.activityList[index].meetingStart,
      meetingEnd: this.activityList[index].meetingEnd,
      startTimeFood: this.activityList[index].startTimeFood,
      endTimeFood: this.activityList[index].endTimeFood,
      reservation: this.activityList[index].reservation,
      paidByFood: this.activityList[index].paidByFood,
      tagMembersFood: this.activityList[index].tagMembersFood,
      otherInfoFood: this.activityList[index].otherInfoFood,
      transNumberFood: this.activityList[index].transNumberFood,
      merchNameFood: this.activityList[index].merchNameFood,
      mealSession: this.activityList[index].merchNameFood,
    });
    this.selectedItems = this.activityList[index].tagMembersFood
  }

  upDateFoodActivity() {
    this.activityList[this.keyIndex] = {
      category: 'Food',
      mealType: this.iconTab.value.mealType,
      restuarant: this.iconTab.value.restuarant,
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      startTimeFood: this.iconTab.value.startTimeFood,
      endTimeFood: this.iconTab.value.endTimeFood,
      reservation: this.iconTab.value.reservation,
      paidByFood: this.iconTab.value.paidByFood,
      tagMembersFood: this.iconTab.value.tagMembersFood,
      otherInfoFood: this.iconTab.value.otherInfoFood,
      transNumberFood: this.iconTab.value.transNumberFood,
      merchNameFood: this.iconTab.value.merchNameFood,
      mealSession: this.iconTab.value.mealSession,
    };

    this.iconTab.patchValue({
      activityDetails: this.activityList,
      mealType: '',
      restuarant: '',
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      startTimeFood: '',
      endTimeFood: '',
      reservation: '',
      paidByFood: '',
      tagMembersFood: '',
      otherInfoFood: '',
      transNumberFood: '',
      merchNameFood: '',
      mealSession: '',
    });
    this.keyIndex = -1;
  }

  selectFoodStartDate(event) {
    console.log(event);
    this.startDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingStartDate: finalDate
    })
    this["meetingStart"] = finalDate;
  }

  selectFoodEndDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingEndDate: finalDate
    })
    this["meetingEnd"] = finalDate;
  }

  getMinDate() {
    if (this.startDate) {
      return (this.startDate)
    } else {
      return this.minDate
    }
  }

  readableDateFormat(userDate: any) {
    if (!_.isObject(userDate)) {
      return userDate;
    } else {
      let year = userDate.year;
      let month = userDate.month <= 9 ? '0' + userDate.month : userDate.month;;
      let day = userDate.day <= 9 ? '0' + userDate.day : userDate.day;;
      let finalDate = day + "-" + month + "-" + year;
      return finalDate;
    }
  }

  addNewItem() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Save?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
    if (!this.iconTab.value.mealSession || !this.iconTab.value.mealType
      || !this.iconTab.value.meetingStart || this.iconTab.value.tagMembersFood.length == 0 ) {
      this.alertService.showError('Mandatory fields to be filled !');
      return false;
    }

    let isMatch = _.isMatch(this.data, this.iconTab.value);
    if (isMatch && this.isActivityEdit) {
      this.alertService.showError('No Changes made to amend !', 3000, 'Invalid update !')
      return false;
    }

    let activityDiffList = [];
    if(!isMatch && this.isActivityEdit){
      let that = this;
      let old = _.clone(this.data), fresh = _.clone(this.iconTab.value);
      _.each(this.verifyFields, function(field){
        let newVal = fresh[field.key], oldVal = old[field.key];
        if (old[field.key] != fresh[field.key]){

          // if (field.key == 'meals' && newVal == 'No') {
          //   newVal = fresh['meals']
          // } else {
          //   newVal = fresh['meals']
          // }

          activityDiffList.push({
            key: field.key,
            name: field.value,
            oldVal: field.isDate ? that.readableDateFormat(old[field.key]) : oldVal,
            newVal: field.isDate ? that.readableDateFormat(fresh[field.key]) : newVal
          })
        }
      })
    }

    console.log('am in addNewItem ', activityDiffList, this.activityList, this.iconTab.value);
    this.flightData.emit({...this.iconTab.value, activityDiffList: activityDiffList, key: this.code, snapList:this.snapList, category:'Food', uniqueId: uuidv4(), addedBy: this.addedBy});
    this.closeModal();
  }
})
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  chooseFile() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Upload Confirmation Doc?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
    document.getElementById("avatar").click();
  }
})
  }

  upload() {
    // Create a root reference
    let storageRef = firebase.storage().ref();
    this.isUploading = true;
    let that = this;

    for (let selectedFile of [(<HTMLInputElement>document.getElementById('avatar')).files[0]]) {
      // let path = '/BILLS/' + Date.now() + `${selectedFile.name}`;
      let path = '/BILLS/' + Date.now() + '_' + `${selectedFile.name}`;
      let iRef = storageRef.child(path);
      iRef.put(selectedFile).then((snapshot) => {
        snapshot.ref.getDownloadURL()
          .then((url) => {
            let images = that.snapList || [];
            images.push(url);
            that.snapList = images;
            this.isUploading = false;
          })
      });
    }
  }

  removeImage(index: any) {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Remove?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
    this.snapList.splice(index, 1);
  }
})
  }

  getFileName(url: any) {
    let data = '';
    if (url.split('_')[1]) {
      data = url.split('_')[1].split('?');
      data = data[0] ? decodeURI(data[0]) : '';
      return data;
    } else {
      return data;
    }
  }

}
